/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'components/Grid';
import { Form, Formik } from 'formik';
import {
  MobileLabel,
  FilterContainer,
  RowFilterIcon,
  FilterSearchContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  ColIcon,
  FieldGrid,
} from './styles'
import { Button } from 'components';
import Icon from 'components/Icon';
import { Label, CheckBox, SelectField, InputField } from '@fitinsur/components';


const ListHeader = (props) => {
  const formik = useRef(null);

  const initialValues = {
    search: ''
  };

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    props.formikRef(formik)
  }, [])


  return (
    <Formik
      onSubmit={(values) => {
        props.updateFilter(values)
      }}
      initialValues={initialValues}
      innerRef={formik}
      enableReinitialization={true}

    >
      {(formikProps) => {

        return (
          <Form>
            <RowFilterIcon>
              <FilterContainer className={showFilter ? 'filter-open' : 'filter-close'}>
                <Row style={{ paddingBottom: '30px' }}>
                  <Col style={{ display: "flex", justifyContent: 'flex-end' }}>
                    <Icon name="close" className="icon-close" onClick={() => setShowFilter(false)} />
                  </Col>
                </Row>

                <FilterSearchContainer>
                  <Row>
                    <MobileLabel>
                      FILTER
                    </MobileLabel>
                  </Row>
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <CheckBox
                          checked={formikProps.values.search.length}
                          onChange={() => formik.current.setFieldValue('search', '')}
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <FieldGrid
                        name="search"
                        placeholder="Search"
                        value={formikProps.values.search}
                        component={InputField}
                        type="text"
                        onChange={(e) => {
                          formikProps.setFieldValue('search', e)
                        }}
                        validation={false}
                        list={true}
                        onPressEnter={() => {
                          formikProps.submitForm()
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <CheckBox
                          checked={formikProps.values.idOperation}
                          onChange={() => formik.current.setFieldValue('idOperation', '')}
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <FieldGrid
                        name="idOperation"
                        placeholder="Operation"
                        component={SelectField}
                        options={props.operationsList || []}
                        validation={false}
                        value={formikProps.values.idOperation}
                        filter={true}
                        onChange={(e) => {
                          formikProps.setFieldValue('idOperation', e);
                          formikProps.submitForm()
                        }}
                        corDiferente={false}
                      />
                    </FilterColumn>
                  </RowFilter>
                </FilterSearchContainer>

                <Row align="center" className='apply-button-container'>
                  <Col>
                    <Button
                      primary
                      type="button"
                      id="btnFilter"
                      style={{ textAlign: "center" }}
                      onClick={(e) => {
                        setShowFilter(false);
                        formikProps.submitForm();
                      }}
                    >
                      Apply
                    </Button>
                  </Col>
                </Row>
              </FilterContainer>

              <ColIcon>
                <Icon name="filter" onClick={() => setShowFilter(!showFilter)} />
              </ColIcon>
              <ColIcon>
                <Icon name="filterCan" onClick={(e) => {
                  formikProps.resetForm(initialValues);
                  formikProps.submitForm(initialValues);
                }} />

              </ColIcon>
            </RowFilterIcon>
          </Form>
        )
      }}

    </Formik>
  )
}

export default ListHeader;
